/**
 * Ammo registration reasons. Keep in sync with backend/lib/ammo-reasons.js.
 * Only `sale` is revenue; every other reason becomes sale status 1006 Forbruk.
 */
export const AMMO_REASONS = [
    { key: 'sale', label: 'Salg', isRevenue: true },
    { key: 'sightingIn', label: 'Innskyting', isRevenue: false },
    { key: 'safetyCourse', label: 'Sikkerhetskurs', isRevenue: false },
    { key: 'guestShooting', label: 'Gjesteskyting', isRevenue: false },
    { key: 'competition', label: 'Stevne', isRevenue: false },
    { key: 'clubWeapon', label: 'Klubbvåpen', isRevenue: false },
    { key: 'otherInternal', label: 'Annet internt', isRevenue: false },
];

export const PAYMENT_METHODS = [
    ['cash', 'Kontant'],
    ['card', 'Kort'],
    ['vipps', 'Vipps'],
    ['account', 'Konto'],
];

export function reasonLabel(key) {
    const reason = AMMO_REASONS.find(r => r.key === key);
    return reason ? reason.label : key;
}

export function isRevenueReason(key) {
    const reason = AMMO_REASONS.find(r => r.key === key);
    return !!(reason && reason.isRevenue);
}

export function todayIso() {
    const d = new Date();
    const pad = n => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
